import { Box, Button, Card, Heading, Icon, Paragraph } from '@zillow/constellation-10';
import { IconBlueprintFilled } from '@zillow/constellation-icons';

type Props = {
  setDisplayCreateNewTaskModal: (value: boolean) => void;
};

export const NoTasksEmptyState = ({ setDisplayCreateNewTaskModal }: Props) => {
  return (
    <Card
      data-testid="empty-leases-card"
      tone="neutral"
      elevated={false}
      css={{ paddingInline: 'looser', paddingBlock: 'loosest' }}
    >
      <Box css={{ textAlign: 'center', margin: '0 auto', maxWidth: '608px' }}>
        <Icon
          render={<IconBlueprintFilled />}
          size="xl"
          css={{ color: 'icon.accent.blue.hero', marginBottom: 'tight' }}
        />

        <Heading level={2} textStyle="heading-sm" css={{ marginBottom: 'tight' }}>
          Track your maintenance tasks
        </Heading>

        <Paragraph css={{ marginBottom: 'looser' }}>
          Keep track of routine or emergency repairs, and their resolutions, all in one place. Create tasks, record
          costs, add photos, and more.
        </Paragraph>

        <Button tone="brand" emphasis="filled" onClick={() => setDisplayCreateNewTaskModal(true)}>
          Create new task
        </Button>
      </Box>
    </Card>
  );
};
